import React, { useEffect } from 'react';
import './CookiePolicyBottomSheet.css';

const CookiePolicyBottomSheet = ({ isOpen, onClose }) => {
    // Prevent scrolling on body when bottom sheet is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            <div className={`cp-sheet-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
            <div className={`cp-sheet-bottom-sheet ${isOpen ? 'show' : ''}`}>
                <div className="cp-sheet-header">
                    <div className="cp-sheet-drag-handle" onClick={onClose}></div>
                    <button className="cp-sheet-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="cp-sheet-content">
                    <div className="cp-sheet-header-section">
                        <h1 className="cp-sheet-title cp-sheet-font-heading">Cookie Policy</h1>
                    </div>

                    <div className="cp-sheet-section">
                        <h3 className="cp-sheet-font-heading">WHAT ARE COOKIES?</h3>
                        <p>Cookies are small files stored on your device when you visit a website.</p>
                        <p> They help improve 
performance, personalise experiences, and support analytics.</p>
                    </div>

                    <div className="cp-sheet-section">
                        <h3 className="cp-sheet-font-heading">WHY  WE USE COOKIES?</h3>
                        <p>We use:</p>
                        <ul>
                            <li><strong>Essential Cookies:</strong>  for basic site functionality </li>
                            <li><strong>Performance Cookies:</strong> enhance speed & user experience</li>
                            <li><strong>Analytics and Customization Cookies:</strong>  understand site usage </li>
                            <li><strong>Advertising Cookies:</strong>show relevant ads .</li>
                        </ul>
                    </div>

                    <div className="cp-sheet-section">
                        <h3 className="cp-sheet-font-heading">YOUR COOKIE CONTROLS </h3>
                        <p>● Your browser settings 
● Our Cookie Consent Manager</p>
  <p>Disabling cookies may affect site functionality. </p>
                    </div>

                    <div className="cp-sheet-section">
                        <h3 className="cp-sheet-font-heading">UPDATES </h3>
                        <p>This Cookie Policy may be updated periodically. </p>
                    </div>

                    <div className="cp-sheet-section">
                        <h3 className="cp-sheet-font-heading">MORE INFO</h3>
                        <p>Email: <strong>aarohfood@gmail.com</strong>.</p>
                    </div>

                </div>
            </div>
        </>
    );
};

export default CookiePolicyBottomSheet;
